import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Content = ({ className, children }: Props) => {
    return <p className={cn("tw:p-0 tw:m-0", className)}>{children}</p>;
};
